import { FieldGeneratorFieldType } from "../../FormFields/FieldGenerator/FieldGenerator"
import { SelectWithOtherField } from "../../FormFields/SelectWithOtherInput/SelectWithOtherField"

export const bookingStatusFieldValues = [
  { value: 'new', text: 'New' },
  { value: 'pending', text: 'Pending' },
  { value: 'confirmed', text: 'Confirmed' },
  { value: 'canceled', text: 'Canceled' },
  { value: 'declined', text: 'Declined' },
  { value: 'expired', text: 'Expired' },
  { value: 'request', text: 'Request' },
  { value: 'ignore', text: 'Ignore' },
]

export const cancellationAmountTypeFieldValues = [
  { value: 'percentage', text: 'Percentage' },
  { value: 'flat', text: 'Flat' },
]

export const bookingFeeTypeFieldValues = [
  { value: 'merchant', text: 'Merchant' },
  { value: 'provider', text: 'Provider' },
]

export const bookingFeeSourceFieldValues = [
  { value: 'stripe', text: 'Stripe' },
  { value: 'vrbo', text: 'VRBO' },
]

export const bookingFeesFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'custom',
    fieldLabel: 'Fee Type',
    placeholder: '- Select Fee Type -',
    fieldName: 'feeType',
    options: bookingFeeTypeFieldValues,
    required: true,
    extra: { component: SelectWithOtherField },
    layout: { xs: 12, md: 4 },
  },
  {
    fieldType: 'custom',
    fieldLabel: 'Fee Source',
    placeholder: '- Select Fee Source -',
    fieldName: 'feeSource',
    options: bookingFeeSourceFieldValues,
    required: true,
    extra: { component: SelectWithOtherField },
    layout: { xs: 12, md: 4 },
  },
  {
    fieldType: 'number',
    fieldLabel: 'Fee Amount',
    placeholder: 'Fee Amount',
    fieldName: 'feeAmount',
    required: true,
    layout: { xs: 12, md: 4 },
  },
]

export const bookingSourceFieldValues = [
  { value: 'airbnb', text: 'AirBnB' },
  { value: 'booking', text: 'Booking.com' },
  { value: 'blueground', text: 'Blueground' },
  { value: 'expedia', text: 'Expedia' },
  { value: 'vrbo', text: 'VRBO' },
  { value: 'direct', text: 'Direct' },  
  { value: 'website', text: 'Website' },
  { value: 'homeaway', text: 'Homeaway' },
  { value: 'owner', text: 'Owner' },
  { value: 'owner-guest', text: 'Owner Guest' },
  { value: 'hotel', text: 'Hotel' },
  { value: 'google', text: 'Google' },
  { value: 'influencer', text: 'Influencer' },
  { value: 'personal', text: 'Personal' },
  { value: 'repairs', text: 'Repairs' },
  { value: 'blocked', text: 'Blocked' },
  { value: 'self', text: 'Self' },
  // Zelle, Cash, Wire, Paypal
  { value: 'zelle', text: 'Zelle' },
  { value: 'cash', text: 'Cash' },
  { value: 'wire', text: 'Wire' },
  { value: 'paypal', text: 'Paypal' },
  { value: 'other', text: 'Other' },
]

const generateBookingSourceFieldValues = () => {
  const bookingSourceRef: {[v: string]: string} = {}
  bookingSourceFieldValues.forEach(bookingSource => {
    // if(bookingSource.value !== 'other') {
      bookingSourceRef[bookingSource.value] = bookingSource.text
    // }
  })
  return bookingSourceRef
}

export const bookingSourceFieldValuesRef = generateBookingSourceFieldValues()